export default "<div>\n    <!--<app-full-index></app-full-index>-->\n    <app-container-documents></app-container-documents>\n</div>\n"